import React, { ComponentPropsWithRef, PropsWithChildren } from "react";

type PillColor = "green" | "grey" | "blue" | "yellow" | "purple";

export const renderCellWithPills = (
  data: Array<{ id: string; name: string }> | any
) => {
  let pills = [];
  if (data && Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      pills.push(
        <span className="pill" key={data[i].id}>
          {data[i].name}
        </span>
      );
    }
  }

  return (
    <div data-testid="table-cell-pill" className="cell-pills-container">
      {data ? pills : ""}
    </div>
  );
};

export const renderCellWithColoredPills = (data: string, color: PillColor) => {
  return (
    <div data-testid="table-cell-colored-pill" className="cell-pills-container">
      <span className={`pill ${color}Pill`}>{data}</span>
    </div>
  );
};

export const renderCellAsImage = (data: string) => {
  let imgEle: string | JSX.Element = data;
  if (data) {
    imgEle = (
      <img
        data-testid="table-cell-image"
        className="cell-image"
        src={data}
        alt=""
        referrerPolicy="no-referrer"
      />
    );
  }
  return imgEle;
};

export interface Props extends PropsWithChildren<ComponentPropsWithRef<"td">> {
  children?: React.ReactNode;
  isHeadCell?: boolean;
}

const TableCell = (props: Props) => {
  const { isHeadCell, ...filteredProps } = props; // Destructuring and remove isHeadCell

  if (isHeadCell) {
    return (
      <th data-testid="table-cell" {...filteredProps}>
        {props.children}
      </th>
    );
  } else {
    return (
      <td data-testid="table-cell" {...filteredProps}>
        {props.children}
      </td>
    );
  }
};

export default TableCell;
